<template>
  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div class="card h-100 pb-3 pt-3">
      <div class="card-header">
        <div class="row">
          <div class="col-6 d-flex justify-content-start align-items-center">
            <h6>{{ domain }} : Response Time</h6>
          </div>
          <div class="col-6 d-flex justify-content-end align-items-center">
              <span class="time-font"><strong>{{ dateTime }}</strong> <small class="text-muted est-font">(EST)</small></span>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-5">
          <div class="col-md-3 col-sm-3 d-flex justify-content-start align-items-start p-l-0 p-r-0">
            <div class="d-flex flex-column w-100"> <!-- Added flex-column to stack children vertically -->
              <div class="d-flex flex-column align-items-start w-100 mb-5">
                <label class="mb-0">From: <strong style="color: red">*</strong></label>
                <date-range-picker
                    class="w-100"
                    ref="picker"
                    :single-date-picker="true"
                    :showDropdowns="true"
                    :auto-apply="true"
                    :timePicker="true"
                    :timePicker24Hour="true"
                    :max-date="searchQuery.end.startDate"
                    :show-custom-ranges="false"
                    :ranges="false"
                    v-model="searchQuery.start"
                >
                  <template v-slot:input="picker" style="min-width: 350px; max-width: 350px">
                    {{ (picker.startDate) ? formattedDate(picker.startDate) : 'From' }}
                  </template>
                </date-range-picker>
              </div>
              <div class="d-flex flex-column align-items-start w-100">
                <label class="mb-0">To:</label>
                <date-range-picker
                    class="w-100"
                    ref="picker"
                    :single-date-picker="true"
                    :showDropdowns="true"
                    :auto-apply="true"
                    :timePicker="true"
                    :ranges="false"
                    :timePicker24Hour="true"
                    :min-date="searchQuery.start.startDate"
                    :time-zone="'America/New_York'"
                    v-model="searchQuery.end"
                >
                  <template v-slot:input="picker" style="min-width: 350px;">
                    {{ (picker.endDate) ? formattedDate(picker.endDate) : 'To' }}
                  </template>
                </date-range-picker>
              </div>
              <div class="d-flex align-items-end w-100">
                <button class="btn btn-primary text-start mb-1" @click="getResults()" :disabled="loading" >Search</button>
                <button class="btn btn-grey text-start mb-1" @click="clearSearch()" :disabled="loading" >Clear</button>
              </div>
            </div>
          </div>
          <div class="col-md-1 d-flex align-items-center justify-content-center">
            <div class="border-start h-100" style="width: 1px; background-color: #ddd;"></div>
          </div>
          <div class="col-md-8 col-sm-8 d-flex justify-content-end align-items-center p-l-0 p-r-0">
            <div class="container">
              <div class="row">
                <div class="col-md-3">
                  <div class="d-flex flex-column">
                    <button class="btn btn-link text-start p-0 mb-1" @click="selectFilter('last2days')" :class="preset === 'last2days'  ? 'active' : '' ">Last 2 days</button>
                    <button class="btn btn-link text-start p-0 mb-1" @click="selectFilter('last7days')" :class="preset === 'last7days'  ? 'active' : '' ">Last 7 days</button>
                    <button class="btn btn-link text-start p-0 mb-1" @click="selectFilter('last30days')" :class="preset === 'last30days'  ? 'active' : '' ">Last 30 days</button>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="d-flex flex-column">
                    <button class="btn btn-link text-start p-0 mb-1" @click="selectFilter('yesterday')" :class="preset === 'yesterday'  ? 'active' : '' ">Yesterday</button>
                    <button class="btn btn-link text-start p-0 mb-1" @click="selectFilter('dayBeforeYesterday')" :class="preset === 'dayBeforeYesterday'  ? 'active' : '' ">Day before yesterday</button>
                    <button class="btn btn-link text-start p-0 mb-1" @click="selectFilter('thisDayLastWeek')" :class="preset === 'thisDayLastWeek'  ? 'active' : '' ">This day last week</button>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="d-flex flex-column">
                    <button class="btn btn-link text-start p-0 mb-1" @click="selectFilter('today')" :class="preset === 'today'  ? 'active' : '' ">Today</button>
                    <button class="btn btn-link text-start p-0 mb-1" @click="selectFilter('todaySoFar')" :class="preset === 'todaySoFar'  ? 'active' : '' ">Today so far</button>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="d-flex flex-column">
                    <button class="btn btn-link text-start p-0 mb-1" @click="selectFilter('last5min')" :class="preset === 'last5min'  ? 'active' : '' ">Last 5 minutes</button>
                    <button class="btn btn-link text-start p-0 mb-1 " @click="selectFilter('last15min')" :class="preset === 'last15min'  ? 'active' : '' ">Last 15 minutes</button>
                    <button class="btn btn-link text-start p-0 mb-1" @click="selectFilter('last6hours')" :class="preset === 'last6hours'  ? 'active' : '' ">Last 6 hours</button>
                    <button class="btn btn-link text-start p-0 mb-1" @click="selectFilter('last12hours')" :class="preset === 'last12hours'  ? 'active' : '' ">Last 12 hours</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref="chartContainer" style="width: 100%; height: 600px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import dateMixin from "@/mixins/dateMixin";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import 'moment-timezone';
import graphDateRangeMixin from "@/mixins/monitor/graphDateRangeMixin";
import swal from "sweetalert2";
import {db} from "@/firebase/init";

export default {
  name: "graph",
  data() {
    return {
      preset : 'last12hours',
      domain: null,
      loading: true,
      dateTime: null,
      initialDelayTime: null,
      searchQuery: {
        start: {
          startDate: null,
        },
        end: {
          endDate: null,
        }
      },
      chart: null,
      chartDetails : {
        time: {
          timezone: 'America/New_York'
        },
        chart: {
          type: 'line',
          zoomType: 'x',
          backgroundColor: '#f5f5f5',
          gridLineWidth: 1,
          gridLineColor: '#e0e0e0',
          events: {
            load: function() {
              // After chart is loaded

              // Get all legend buttons
              const buttons = document.querySelectorAll('.legend-button');

              // Add click handlers
              buttons.forEach(button => {
                button.addEventListener('click', function() {
                  // Your custom click handling logic here
                  // For example, toggle series visibility or apply filters

                  // Toggle active class for styling
                  this.classList.toggle('active');
                });
              });
            }
          }
        },
        title: {
          text: null
        },
        xAxis: {
          type: 'datetime',
          steps: 20,
          enabled: false,
          gridLineWidth: 1,
          tickInterval: null,
          events: {
            afterSetExtremes: function (e) {
              let range = e.max - e.min;
              let tickInterval = range / 30;
              this.update({ tickInterval });
            }
          },
          labels: {
            formatter: function () {
              let date = moment.tz(this.value, "America/New_York");

              let formattedTime = date.format("DD/MM/YYYY HH:mm"); // Default without seconds
              if (date.seconds() !== 0) {
                formattedTime = date.format("DD/MM/YYYY HH:mm:ss"); // Include seconds if not 00
              }

              return formattedTime;
            },
            rotation: -90,
            y: 20,
            offset: 40,
            align: 'right',
            style: {
              fontSize: '10px'
            }
          },
          minorTickInterval: null,

          // Add padding to the axes to give more space
          minPadding: 0.05,
          maxPadding: 0.05
        },
        yAxis: {
          title: {
            text: 'Response Time (s)'
          },
          min: 0.5, // Set min value similar to the chart in the image
          max: 2.4, // Set max value similar to the chart in the image
          gridLineWidth: 1,
        },
        legend: {
          enabled: true,
          align: 'right',
          verticalAlign: 'top',
          useHTML: true,
          labelFormatter: function() {
            // Create button-like appearance for each legend item
            return '<button class="legend-button">' + this.name + '</button>';
          },
          title: {
            text: 'Select filter',
            style: {
              fontWeight: 'bold',
              fontSize: "0.9em",
            }
          }
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          formatter: function() {
            let date = moment.tz(this.x, "America/New_York");
            let formattedTime = date.format("DD/MM/YYYY HH:mm:ss");
            let tooltip = '<b>' + formattedTime + '</b><br/>';
            this.points.forEach(point => {
              tooltip += '<span style="color:' + point.series.color + '">\u25CF</span> ' +
                  point.series.name + ': <b>' + point.y.toFixed(2) + 's</b><br/>';
            });
            return tooltip;
          }
        },
        plotOptions: {
          line: {
            marker: {
              enabled: false
            }
          },
          series: {
            states: {
              hover: {
                enabled: true,
                lineWidth: 2
              }
            }
          }
        },
        series: [
          {
            name: 'UK',
            color: '#2f7ed8', // Blue line similar to the chart in the image
            data: [] // Will be populated with data
          },
          {
            name: 'USA',
            color: '#5cb85c', // Green line similar to the chart in the image
            data: [] // Will be populated with data
          }
        ],
      }
    }
  },
  mixins: [dateMixin, graphDateRangeMixin],
  components: {DateRangePicker},
  async mounted() {
    await this.fetchMonitorDetails()
    this.updateDateTime();
    this.timer = setInterval(() => {
      this.updateDateTime();
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
    }, 1000);

     this.initChart();
    await this.selectFilter(this.preset)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    async selectFilter(present){
      this.preset = present;
      const data = this.setDateRange(present);
      await this.fetchMonitorGraphDetails(data.start, data.end);
    },
    async clearSearch(){
      this.searchQuery.start.startDate = null;
      this.searchQuery.end.startDate = null;
    },
    async getResults(){
      const {start, end} = this.searchQuery;
      const isValidStartDate = moment(start.startDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z", true).isValid();
      const isValidEndDate = moment(end.endDate, "ddd MMM DD YYYY HH:mm:ss [GMT]Z", true).isValid();
      console.log(isValidStartDate, isValidStartDate );
     if(!isValidStartDate && !isValidEndDate) {
       await this.fetchMonitorGraphDetails(this.initialDelayTime);
     }
     else if(isValidEndDate && isValidStartDate) {
       console.log(start.startDate, 'this here');
       const startDate = this.formatDateFromResults(start.startDate)
       const endDate = this.formatDateFromResults(end.endDate)

       await this.fetchMonitorGraphDetails(startDate, endDate);
     }
     else if (isValidStartDate) {
       console.log(start.startDate, 'this here');
       const startDate = this.formatDateFromResults(start.startDate)
       await this.fetchMonitorGraphDetails(startDate);
     }
     else{
       // await this.fetchMonitorDetails(this.initialDelayTime);

       // todo
     }

    },
    updateDateTime(){
      let now = new Date();
      const easternTime = now.toLocaleString('en-US', {
        timeZone: 'America/New_York',
      });
      this.dateTime=moment(easternTime).format("HH:mm")

      this.initialDelayTime = moment()
          .tz("America/New_York")
          .subtract(6, "hours")
          .format("YYYY-MM-DDTHH:mm:ss");
    },
    initChart() {
      Highcharts.setOptions({
        time: {
          timezone: 'America/New_York'  // Set your desired timezone
        }
      });
      this.chart = Highcharts.chart(this.$refs.chartContainer, {...this.chartDetails}
      );
    },
    async fetchMonitorDetails(){
      const monitorId = this.$route.params.id;
      const monitorRef = await db.collection('zabbixMonitors').doc(monitorId).get();
      if(monitorRef.exists){
        const monitorData  = await monitorRef.data();
        this.domain = monitorData.url;
      }
      else{
        await swal('Error', 'No record exist', 'error');
      }
      console.log(monitorRef, 'red alert');
    },
    async fetchMonitorGraphDetails(startDate = null, endDate = null) {
      this.loading = true;
      const payload = {
        monitorId: this.$route.params.id,
        timeFrom : startDate,
      }
      if(endDate){
        payload.timeTo = endDate;
      }
      this.chart.showLoading('loading records...');
      try {
        const response = await this.$http.post('zabbix/graph', {
          grant_type: 'token',
          ...payload,
        });

        const data = response.data;

        const UKData = [];
        const USAData = [];
        let UKMax = 0;
        let USAMax = 0;
        if (data) {
          if(!data.UK.length && !USAData.length) {
            this.chart.hideLoading();

            this.chart.yAxis[0].update({
              min: 0,
              max: 0
            });
            this.chart.series[0].setData([]);
            this.chart.series[1].setData([]);
            return;
          }

          let UKMin = data.UK[0].item   // considering first number is the lowest
          let USAMin = data.USA[0].item
          data.UK.forEach(item => {
            this.chart.hideLoading();
            const estTime = item.time;
            const time =  moment.unix(estTime).tz("America/New_York").format("YYYY-MM-DD hh:mm:ss A z");
            console.log(time, "UK")
            UKData.push([estTime*1000, parseFloat(item.value)]);

            UKMax = UKMax > item.value ? UKMax : item.value;
            UKMin = UKMin < item.value ? UKMin : item.value;
          });
          data.USA.forEach(item => {
            const estTime = item.time;
            const time =  moment.unix(estTime).tz("America/New_York").format("YYYY-MM-DD hh:mm:ss A z");
            console.log(time, "UK")
            USAData.push([estTime*1000, parseFloat(item.value)]);

            USAMax = USAMax > item.value ? USAMax : item.value;
            USAMin = USAMin < item.value ? USAMin : item.value;
          })

          this.chartDetails.yAxis.max = USAMax < UKMax  ? UKMax : USAMax;
          this.chartDetails.yAxis.min = USAMin < UKMin  ? USAMin : UKMin;
          this.chart.hideLoading();
          this.chart.yAxis[0].update({
            min: this.chartDetails.yAxis.min,
            max: this.chartDetails.yAxis.max
          });

          // Update the chart with new data
          this.chart.series[0].setData(UKData);
          this.chart.series[1].setData(USAData);

        }
      } catch (error) {
        await swal('Error', 'Something went wrong fetching monitor results', 'error');
        console.error('Error fetching monitor details:', error.toString());
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>


<style scoped>
.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5B7CFB;
}
.time-font{
  font-size : 35px;
  font-family: 'Orbitron';
}
:deep(.reportrange-text){
  display: flex !important;
  align-items: center !important;
}
:deep(.legend-button) {
  font-weight: bold;
  padding: 1px 15px;
  margin: 0 5px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
}

:deep(.legend-button:hover){
  background-color: #e9ecef;
}

/* For active state */
:deep(.legend-button.active){
  background-color: gray;
  color: white;
  border-color: grey;
}
</style>

